// extracted by mini-css-extract-plugin
export default {"validationBadge":"validationBadge__validationBadge-a5mUu"};